module.exports = __webpack_public_path__ + "img/sheriff-tusc-logo.00a59fb8.jpg";